import * as ClickTracker from "../trackers/click/click.tracker";
import { hasTrackingEventSuffix } from "../trackers/utils";

interface InteractionEvent {
    target: InteractionElement;
}

interface InteractionElement {
    closest(selector: string): HTMLElement;
}

const isValidInteractionTarget = (event: InteractionEvent) => {
    return event.target && typeof event.target.closest === "function";
};

const getWrappingTrackingElement = (e: InteractionEvent): HTMLElement => {
    return e.target.closest("[data-tracking-event]");
};

const trackGenericClickInteractions = (): void => {
    document.addEventListener(
        "click",
        (e: any): void => {
            if (isValidInteractionTarget(e)) {
                const element = getWrappingTrackingElement(e);
                const anchorElement = e.target?.closest("a") || e.target;
                const isAnchorTag = anchorElement.tagName === "A";

                if (element && hasTrackingEventSuffix(element, "-click")) {
                    ClickTracker.trackElementWithAttributes(
                        element,
                        anchorElement
                    );
                } else {
                    if (isAnchorTag) {
                        ClickTracker.trackElementWithAttributes(anchorElement);
                    }
                }
            }
        },
        false
    );
};

export { trackGenericClickInteractions };
